import React from 'react'
import { Link } from 'react-router-dom'
import ApWordmark from './platform/ApWordmark'
import './platform/platform.css'
import './public-folio.css'

const Footer = () => {
  return (
    <footer className="ap-public-footer bg-slate-50 border-t border-slate-200 py-16 relative overflow-hidden text-slate-500">
      <div className="container mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="mb-6"><ApWordmark /></div>
            <p className="text-slate-500 mb-6 font-medium leading-relaxed max-w-sm text-sm">
              A calm, course-aware study space for understanding, practising, and remembering across your AP subjects.
            </p>
            <div className="mb-4">
              <h4 className="text-slate-900 font-semibold text-sm mb-2">Contact Us</h4>
              <a href="mailto:sahaladan15@gmail.com" className="text-teal-600 hover:text-teal-700 font-medium transition-colors duration-300">
                sahaladan15@gmail.com
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-slate-900 font-semibold text-lg mb-6">
              Directory
            </h3>
            <ul className="space-y-2">
              <FooterLink text="Blog" href="/blog" />
              <FooterLink text="Privacy Policy" href="/privacy-policy" />
              <FooterLink text="Terms of Service" href="/terms-of-service" />
              <FooterLink text="FAQs" href="/#faq" />
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-12 pt-8 text-center text-slate-400 font-medium text-sm">
          <p>APDoneRight &copy; {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

const FooterLink = ({ text, href = "#" }) => {
  return (
    <li>
      <a href={href} className="text-slate-500 font-medium hover:text-teal-600 transition-colors duration-300">
        {text}
      </a>
    </li>
  )
}


export default Footer 
